export const DIALOG_WIDTH = '650px';
